"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plexoInstrumenSecretConverter = exports.plexoExpressCheckoutConverter = exports.plexoInstrumentRegisterConverter = exports.plexoPurchaseRequestConverter = exports.cobranzaDiariaSistarbancConverter = void 0;
exports.cobranzaDiariaSistarbancConverter = {
    toFirestore(data) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            idEmpresa: data.idEmpresa,
            fecha: data.fecha,
            importeCobradoPesos: data.importeCobradoPesos,
            importeCobradoDolares: data.importeCobradoDolares,
            importeConsolidadoPesos: data.importeConsolidadoPesos,
            importeConsolidadoDolares: data.importeConsolidadoDolares,
            idsTransaccionesCobros: data.idsTransaccionesCobros ?? [],
            idsTransaccionesCobrosConsolidado: data.idsTransaccionesCobrosConsolidado ?? []
        };
    }
};
exports.plexoPurchaseRequestConverter = {
    toFirestore(data) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            plan: data.plan,
            numeroFactura: data.numeroFactura,
            idTarjeta: data.idTarjeta,
            importeSinImpuestos: data.importeSinImpuestos,
            importeTotal: data.importeTotal,
            moneda: data.moneda,
            idEmpresa: data.idEmpresa,
            idsDocumentos: data.idsDocumentos,
            idEmpresaCobra: data.idEmpresaCobra,
            idClientePaga: data.idClientePaga,
            rutClientePaga: data.rutClientePaga,
            nombreClientePaga: data.nombreClientePaga,
            estado: data.estado,
            fechaCreacion: data.fechaCreacion,
            respuestaPlexo: data.respuestaPlexo
        };
    }
};
exports.plexoInstrumentRegisterConverter = {
    toFirestore(data) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            idEmpresa: data.idEmpresa,
            fecha: data.fecha,
            plexoIsSuccess: data.plexoIsSuccess,
            plexoMessage: data.plexoMessage,
            plexoResponseUri: data.plexoResponseUri,
            plexoResponseId: data.plexoResponseId
        };
    }
};
exports.plexoExpressCheckoutConverter = {
    toFirestore(data) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            plexoClient: data.plexoClient,
            gatewayUrl: data.gatewayUrl,
            gatewayReferenceId: data.gatewayReferenceId,
            callbackRecibido: data.callbackRecibido,
            procesadoRecibo: data.procesadoRecibo,
            confirmadoConsolidado: data.confirmadoConsolidado ?? false,
            idEmpresaCobra: data.idEmpresaCobra,
            idClientePaga: data.idClientePaga,
            rutClientePaga: data.rutClientePaga,
            nombreClientePaga: data.nombreClientePaga,
            idsDocumentos: data.idsDocumentos,
            fechaCreacion: data.fechaCreacion,
            fechaCallbackRecibido: data.fechaCallbackRecibido,
            importe: data.importe,
            moneda: data.moneda,
            paymentProcessorId: data.paymentProcessorId ?? "",
            paymentIssuer: data.paymentIssuer ?? ""
        };
    }
};
exports.plexoInstrumenSecretConverter = {
    toFirestore(data) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            SessionId: data.SessionId,
            debitoAutomatico: data.debitoAutomatico,
            idEmpresa: data.idEmpresa,
            creada: data.creada,
            Client: data.Client,
            Action: data.Action,
            PaymentInstrument: data.PaymentInstrument
        };
    }
};
